/**
 * String extension methods for enhanced string manipulation
 */

declare global {
  interface String {
    removeAccentMarks(): string;
  }
}

String.prototype.removeAccentMarks = function (this: string): string {
  return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export {};
